import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      numberOfLeads: { type: Number, default: 0 },
      selectedLeadIds: { type: Array, default: [] },
    }
  }

  submit() {
    // Dispatch custom event to open the React Sheet component
    const leadIds = this.selectedLeadIdsValue.length > 0
      ? this.selectedLeadIdsValue
      : []

    const filters = this.selectedLeadIdsValue.length === 0
      ? this.filtersValue
      : {}

    document.dispatchEvent(
      new CustomEvent("open-lookalikes-sheet", {
        detail: { leadIds, filters },
      }),
    )
  }

  // This function is triggered using stimulus actions to update the selected leads value.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets.map(dataSet => dataSet.leadId || dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
